import {
	Alert,
	Button,
	Loading,
	Modal,
	SearchSelect,
	SearchSelectOptionProps,
} from "@alm/flow-ds/components";
import FormID from "../FormID";
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import api from "lib/api";
import axios from "axios";

export default () => {
	const { t } = useTranslation();

	const [loading, setLoading] = useState<boolean>(true);
	const [alert, setAlert] = useState<boolean>(false);
	const [disabled, setDisabled] = useState<boolean>(false);

	const [options, setOptions] = useState<SearchSelectOptionProps[]>([]);
	const [formId, setFormId] = useState<string | undefined>(undefined);
	const [formEntity, setFormEntity] =
		useState<SearchSelectOptionProps | null>(null);

	const [isValid, setIsValid] = useState<boolean>(false);
	const [createOpen, setCreateOpen] = useState<boolean>(false);

	const history = useHistory();

	const retrieveEntities = useCallback(async () => {
		try {
			const entityOptions = await api.entity.getEntities();
			setOptions([
				{
					label: t("formDesigner.labels.noEntity"),
					value: "NoEntity",
				},
				...entityOptions,
			]);
		} catch (error) {
			setAlert(true);
			setDisabled(true);
			if (error && axios.isAxiosError(error))
				console.error(`Error: ${error.message}`);
		}
		setLoading(false);
	}, [t]);

	useEffect(() => {
		retrieveEntities();
	}, [retrieveEntities]);

	const handleChange = useCallback(e => {
		setFormEntity(e);
	}, []);

	return (
		<>
			<Button
				className="btn-primary"
				label={t("formDesigner.labels.createForm")}
				onClick={() => setCreateOpen(true)}
			/>
			<Modal
				className="create-dialog"
				close={() => setCreateOpen(false)}
				isOpen={createOpen}
				title={t("formDesigner.dialogs.createForm")}
				footer={
					<div className="form-start-card__create-form-btn">
						<Button
							label={t("formDesigner.labels.create")}
							className="btn-primary"
							disabled={
								!(
									isValid &&
									formId?.trim() !== "" &&
									formEntity !== null
								)
							}
							onClick={() =>
								history.push({
									pathname: "/formdesigner/create",
									search: `?formId=${formId?.trim()}&formEntity=${
										formEntity?.value === "NoEntity"
											? "NoEntity"
											: formEntity?.label
									}`,
								})
							}
						/>
					</div>
				}>
				{alert && (
					<Alert
						className="validation-alert form-start-alert mb-4"
						title={t(`alerts.errorLoadingFormList.title`)}
						block={true}
						description={t(
							`alerts.errorLoadingFormList.description`
						)}
						status="error"
						onClose={() => setAlert(false)}
					/>
				)}
				{!loading ? (
					<div className="form-start-card">
						<FormID
							setFormId={setFormId}
							formId={formId}
							isValid={isValid}
							setIsValid={setIsValid}
						/>
						<SearchSelect
							onChange={handleChange}
							options={options}
							required={true}
							label={t("formDesigner.labels.entity")}
							placeholder={t("formDesigner.placeholders.entity")}
							value={formEntity}
							disabled={disabled}
						/>
					</div>
				) : (
					<Loading />
				)}
			</Modal>
		</>
	);
};
